import { useLiquidGlassPress } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { hapticFeedback } from '@tma.js/sdk';
import { FC } from 'react';
import { CommonIcon } from '../common/CommonIcon';

const ROW_DIVIDER_BORDER = '1px solid color-mix(in srgb, var(--tg-theme-text-color) 16%, transparent)';

interface TemplateItemProps {
  name: string;
  description?: string | null;
  isSelected: boolean;
  showDivider: boolean;
  onClick: () => void;
}

export const TemplateItem: FC<TemplateItemProps> = ({
  name,
  description,
  isSelected,
  showDivider,
  onClick,
}) => {
  const { pressed, onPointerDown, onPointerMove, onPointerUp, onPointerCancel, onClick: onPressClick } = useLiquidGlassPress({
    preventDefault: true,
    onActivate: () => {
      hapticFeedback.impactOccurred.ifAvailable('light');
      onClick();
    },
  });

  return (
    <Box
      component="button"
      type="button"
      aria-label={name}
      aria-pressed={isSelected}
      onClick={onPressClick}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
      sx={{
        display: 'block',
        width: '100%',
        m: 0,
        px: '14px',
        py: '12px',
        border: 'none',
        borderTop: showDivider ? ROW_DIVIDER_BORDER : 'none',
        background: 'none',
        textAlign: 'left',
        cursor: 'pointer',
        font: 'inherit',
        color: 'inherit',
        WebkitTapHighlightColor: 'transparent',
        outline: 'none',
        bgcolor: pressed
          ? 'color-mix(in srgb, var(--tg-theme-text-color) 6%, transparent)'
          : isSelected
          ? 'color-mix(in srgb, var(--tg-theme-button-color) 12%, transparent)'
          : 'transparent',
        transition: 'background-color 0.12s ease',
      }}
    >
      <Stack direction="row" alignItems="center" gap="12px">
        <Stack spacing="2px" sx={{ flex: 1, minWidth: 0 }}>
          <Text style={{ fontSize: '15px', fontWeight: 500, color: 'var(--tg-theme-text-color)' }}>
            {name}
          </Text>
          {description && (
            <Text
              style={{
                fontSize: '13px',
                lineHeight: '17px',
                color: 'var(--tgui--hint_color)',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {description}
            </Text>
          )}
        </Stack>
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            flexShrink: 0,
            border: `2px solid ${isSelected ? 'var(--tg-theme-button-color)' : 'var(--tgui--hint_color)'}`,
            backgroundColor: isSelected ? 'var(--tg-theme-button-color)' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {isSelected && (
            <CommonIcon icon="check" type="filled" size={16} color="var(--tg-theme-button-text-color)" />
          )}
        </Box>
      </Stack>
    </Box>
  );
};
